<input aria-label="Keyword" class="form-control" type="text" placeholder="Type to add" [ngModel]="keyword"
	[ngbTypeahead]="typeAheadSearch" [inputFormatter]="inputFormatter" [resultFormatter]="resultFormatter"
	(selectItem)="typeAheadSelected($event)" [resultTemplate]="rt"
	[attr.data-cy]="'AP_Group_Rule_ContactRecordTextInput'" />

<ng-template #rt let-r="result" let-t="term">
	<ngb-highlight [result]="r.title" [term]="t" [attr.data-cy]="r.recordID"></ngb-highlight>
</ng-template>